import { SaleRow } from "@/models/base";
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import { LoyaltyService } from "@/services/loyalty-service";
import { i18n } from "@/setup/i18n-setup";
import { HttpError } from "../services/http-error";
import { SaleEditState } from "./sale-edit-state";

export class SaleEditLoyalty {
	public balance: number | null = null;
	public modalOpen: boolean = false;
	private state: SaleEditState;

	public constructor(state: SaleEditState) {
		this.state = state;
	}

	public isEnabled():boolean {
		if (!AuthService.hasModule(MODULE.WINKELMODULE)) return false;
		return DossierConfigService.getLoyaltyConfig().Enabled;
	}

	public shouldShowButton():boolean {
		if (!this.isEnabled()) return false;
		if (DossierConfigService.getLoyaltyConfig().AlwaysShowButton) {
			return !!this.state.sale.ContactID;
		}
		return this.balance !== null && this.balance != 0;
	}

	public isRedeemAllowed():boolean {
		if (!this.isEnabled()) return false;
		return DossierConfigService.getLoyaltyConfig().EarnSaleTypeIDs.indexOf(this.state.sale.TypeID) != -1;
	}

	public async loadBalance() {
		this.balance = null;
		if (!this.isEnabled()) return;
		if (!this.state.sale.ContactID) return;
		try {
			this.balance = await LoyaltyService.getBalance(this.state.sale.ContactID);
		} catch (err) {
			let e = err as HttpError;
			e.dontShow = true;
			return;
		}
		if (!this.isRedeemAllowed()) return;
		if (this.getRedemptionRow()) return;
		let config = DossierConfigService.getLoyaltyConfig();
		if (config.getRedeemableSteps(this.balance) <= 0) return;
		this.modalOpen = true;
	}

	public getRedemptionRow():SaleRow | null {
		return this.state.sale.Rows.find(r=>r.SaleRowConfig.LoyaltyRedemption) || null;
	}

	public getEarnPreview():number {
		if (!this.isEnabled()) return 0;
		return DossierConfigService.getLoyaltyConfig().getEarnPreview(this.state.sale.TypeID, this.state.sale.Rows);
	}

	public async addRedemptionRow(steps:number) {
		if (steps <= 0) return;
		let config = DossierConfigService.getLoyaltyConfig();
		let row = new SaleRow();
		row.ProductDescription = i18n.t("components.sales.loyalty.discount-row-description").toString();
		row.UnitPrice = -(steps * config.RedeemStepEuro);
		row.Vat = 0;
		row.setAmount(1);
		row.SaleRowConfig.LoyaltyRedemption = true;
		row.SaleRowConfig.LoyaltyRedeemedPoints = steps * config.RedeemStepPoints;
		await this.state.addRows(row);
	}
}
